// import axios from 'axios'
// import { border, borderRadius } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'
import { MdModeEditOutline } from 'react-icons/md'
// import AwsConfig from '../../Config/AwsConfig'
// import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
// import { v4 as uuidv4 } from 'uuid'

export default function GalleryVideos(props) {
  const {
    GalleryVideos,
    inputData,
    sendinputdata,
    sendBooleanValueChangeDone,
    disableInput,
  } = props
  const [VideoPreview, setVideoPreview] = useState('')
  const [VideoTittle, setVideoTittle] = useState('')
  const [EmbedVideoId, setEmbedVideoId] = useState('')
  const [VideoUrl, setVideoUrl] = useState('')
  // const [Thumbnail, setThumbnail] = useState([])
  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (e, position) => {
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    dragOverItem.current = position
  }

  const drop = () => {
    const GalleryVideosImages = [...GalleryVideos]
    const dragItemContent = GalleryVideosImages[dragItem.current]
    GalleryVideosImages.splice(dragItem.current, 1)
    GalleryVideosImages.splice(dragOverItem.current, 0, dragItemContent)
    const inputDataCopy = { ...inputData }
    inputDataCopy.GalleryVideos = GalleryVideosImages
    sendinputdata(inputDataCopy)
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  const PushImagetoArray = async () => {
    const inputDataCopy = { ...inputData }
    // let thumbnailImage = ''
    // if (EmbedVideoId) {
    //   const file = await getImageFromURL(
    //     `https://img.youtube.com/vi/${EmbedVideoId}/mqdefault.jpg`,
    //   )
    //   thumbnailImage = await uploadSelectedImage(file)
    // }

    if (GalleryVideos) {
      if (EmbedVideoId) {
        inputDataCopy.GalleryVideos = [
          {
            path: `https://www.youtube.com/embed/${EmbedVideoId}`,
            title: VideoTittle,
            thumbnail: `https://img.youtube.com/vi/${EmbedVideoId}/mqdefault.jpg`,
          },
          ...GalleryVideos,
        ]
        // getImageFromURL(`https://img.youtube.com/vi/${EmbedVideoId}/mqdefault.jpg`)
      } else {
        inputDataCopy.GalleryVideos = [
          {
            path: VideoUrl,
            title: VideoTittle,
            thumbnail: `https://img.youtube.com/vi/${EmbedVideoId}/mqdefault.jpg`,
          },
          ...GalleryVideos,
        ]
      }
    } else if (EmbedVideoId) {
      inputDataCopy.GalleryVideos = [
        {
          path: `https://www.youtube.com/embed/${EmbedVideoId}`,
          title: VideoTittle,
          thumbnail: `https://img.youtube.com/vi/${EmbedVideoId}/mqdefault.jpg`,
        },
      ]
    } else {
      inputDataCopy.GalleryVideos = [{ path: VideoUrl, title: VideoTittle }]
    }

    sendinputdata(inputDataCopy)
    sendBooleanValueChangeDone('GalleryVideos', true)
    setEmbedVideoId('')
    setVideoTittle('')
    setVideoUrl('')
    setVideoPreview('')
  }

  const removeVideo = index => {
    const inputDataCopy = { ...inputData }
    const GalleryVideosImages = [...GalleryVideos].filter((item, i) => i !== index)
    inputDataCopy.GalleryVideos = GalleryVideosImages
    sendinputdata(inputDataCopy)
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  useEffect(() => {
    if (VideoPreview !== '') {
      if (VideoPreview.includes('https://www.youtube.com/') === false) {
        const url = VideoPreview
        setVideoUrl(url)
      } else if (VideoPreview.includes('embed')) {
        const url = VideoPreview
        const videoId = url.split('embed/')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          setEmbedVideoId(videoId.substring(0, ampersandPosition))
        } else {
          setEmbedVideoId(videoId ? videoId : '')
        }
      } else {
        // EmbedVideoId of youtube
        const url = VideoPreview
        const videoId = url.split('v=')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          setEmbedVideoId(videoId.substring(0, ampersandPosition))
        } else {
          setEmbedVideoId(videoId ? videoId : '')
        }
      }
    }
  }, [VideoPreview])

  const EditVideo = index => {
    const inputDataCopy = { ...inputData }
    // const imageSIzesTemp = [...imageSIzes]
    const GalleryVideosTemp = [...GalleryVideos]
    const EditValue = GalleryVideosTemp.splice(index, 1)
    setVideoTittle(EditValue[0].title)
    setVideoPreview(EditValue[0].path)
    // imageSIzesTemp.splice(index, 1)
    inputDataCopy.GalleryVideos = GalleryVideosTemp
    // setImageSizes(imageSIzesTemp)
    sendinputdata(inputDataCopy)
    // const url = EditValue[0].path
    // const videoId = url.split('embed/')[1]

    // const ampersandPosition = videoId.indexOf('&')
    // if (ampersandPosition > -1) {
    //   setEmbedVideoId(videoId.substring(0, ampersandPosition))
    // } else {
    //   setEmbedVideoId(videoId ? videoId : '')
    // }

    // setVideoUrl('')
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  return (
    <>
      <div>
        <label>Gallery Videos:</label>
        {GalleryVideos && GalleryVideos.length !== 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
            className='rounded'
          >
            {GalleryVideos.map((item, index) => (
              <div
                onDragStart={e => dragStart(e, index)}
                onDragEnter={e => dragEnter(e, index)}
                onDragEnd={drop}
                draggable
                style={{ display: 'flex' }}
                key={index}
              >
                <div
                  className='m-2 rounded'
                  style={{ position: 'relative', border: '1px solid lightgray' }}
                >
                  {/* show video */}
                  <div
                    className='video-container'
                    style={{
                      width: '450px',
                      height: '100%',
                      backgroundColor: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {item.path.includes('https://www.youtube.com/embed/') && (
                      <div key={item.path}>
                        <iframe
                          key={item.path}
                          width='320'
                          height='240'
                          src={item.path}
                          title='YouTube video player'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        ></iframe>
                        <div style={{ display: 'flex' }}>
                          <div className='m-2' style={{ position: 'relative' }}>
                            <label>Thumbnail:</label>
                            <img
                              src={item.thumbnail}
                              alt='poster-url'
                              width='100'
                              height='100'
                              // onLoad={event => imageSize(event)}
                            />
                          </div>
                          <div className='m-2' style={{ position: 'relative' }}>
                            <label>Title:</label>
                            <span>{item.title}</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <button
                      className='removeVideo'
                      type='button'
                      onClick={() => removeVideo(index)}
                    >
                      X
                    </button>
                    <button
                      className='editVideo'
                      type='button'
                      onClick={() => EditVideo(index)}
                      disabled={disableInput === true}
                    >
                      <MdModeEditOutline />
                    </button>
                  </div>
                </div>
                {/* <div
                  className='d-flex justify-content-center align-items-center'
                  style={{ width: '10%' }}
                >
                  {index !== 0 && (
                    <Button
                      variant='primary'
                      className='btn-sm mr-1 ml-1'
                      onClick={() => handleMoveItem('up', index)}
                    >
                      <i className='fa  fa-angle-double-up' />
                    </Button>
                  )}
                  {index !== GalleryVideos.length - 1 && (
                    <Button
                      variant='primary'
                      className='btn-sm mr-1 ml-1'
                      onClick={() => handleMoveItem('down', index)}
                    >
                      <i className='fa  fa-angle-double-down    ' />
                    </Button>
                  )}
                </div> */}
              </div>
            ))}
          </div>
        )}
        <br />
        <div>
          {/* <input
            type='file'
            className='form-control'
            accept='video/*'
            placeholder='please select gallery video'
            onChange={selectVideo}
          /> */}
          <label>Video Path:</label>
          <input
            type='url'
            className='form-control'
            placeholder='please select gallery video'
            value={VideoPreview}
            onChange={e => setVideoPreview(e.target.value)}
            disabled={disableInput === true}
          />
          <label>Video Title:</label>
          <input
            type='text'
            className='form-control'
            placeholder='please enter video title'
            value={VideoTittle}
            onChange={e => setVideoTittle(e.target.value)}
            disabled={disableInput === true}
          />
          {/* preview uploaded images */}
          <div>
            <div
              style={{
                position: 'relative',
                left: '17.813rem',
                top: '4.375rem',
              }}
            >
              {VideoPreview && EmbedVideoId && (
                <button
                  className='remove btn btn-danger'
                  type='button'
                  onClick={() => setVideoPreview('')}
                  disabled={disableInput === true}
                >
                  X
                </button>
              )}
            </div>
            {VideoPreview && EmbedVideoId && (
              <div style={{ display: 'flex', gap: '10px' }}>
                {/* code to display youtube video */}
                {EmbedVideoId && (
                  <iframe
                    width='320'
                    height='240'
                    src={`https://www.youtube.com/embed/${EmbedVideoId}`}
                    title='YouTube video player'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                  ></iframe>
                )}
                {/* {VideoUrl && (
                  <video width='320' height='240' controls>
                    <source src={VideoUrl} />
                  </video>
                )} */}
                <div style={{ position: 'relative', top: '80px' }}>
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={PushImagetoArray}
                    disabled={
                      VideoTittle === '' ||
                      VideoTittle === null ||
                      VideoPreview === '' ||
                      VideoPreview === null ||
                      disableInput === true
                    }
                  >
                    ok
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
